<div class="modal-form container">

    <h2 mat-dialog-title class="jumbotron-heading">Submit Lock Request</h2>
    <lgv-loading-indicator *ngIf="lgvClientSvc.IsOpportunitiesLoading$ | async"
        [CSSClass]="'Small'"></lgv-loading-indicator>

    <div
        *ngIf="((filteredOpportunities$ | async) && (lgvClientSvc.IsOpportunitiesReady$ | async)) && !(authMgr.IsClient$ | async)">
        Rates are live as of {{now | date: 'short'}}.</div>

    <!--<div class="Vert-25"></div>-->

    <mat-dialog-content class="mat-typography">


        <!--<div class="alert alert-warning">
            <div>OpportunitiesState$: {{this.lgvClientSvc.OpportunitiesState$ | async}}</div>
            <div>isSelectOpportunityMode$: {{this.isSelectOpportunityMode$ | async}}</div>
            <div>isHaveSelectedOpportunityMode$: {{this.isHaveSelectedOpportunityMode$ | async}}</div>
            <div>pageMode$: {{this.pageMode$ | async}}</div>
        </div>-->
        <!--Select Opportunity Mode-->
        <ng-container *ngIf="isSelectOpportunityMode$ | async">

            <ng-container *ngIf="lgvClientSvc.IsOpportunitiesReady$ | async">

                <div *ngIf="(filteredOpportunities$ | async) as opportunities">

                    <p>Select the opportunity you want to lock to continue.</p>
                    <div class="Vert-15"></div>

                    <div class="select-opportunity" *ngFor="let o of opportunities">

                        <div class="row justify-content-between detailRow">
                            <div class="col-12 standOutText20B">
                                {{o.opportunityType?.name}} | {{o.opportunityInfo.matchedRate | number : '1.3-3'}}%
                            </div>

                            <div class="col-12 detailValue" style="margin:7px 0 7px 0;">
                                {{o.opportunityInfo?.productName}}</div>

                            <div class="col-2">
                                <div>Rate</div>
                                <div class="detailValue">{{o.opportunityInfo.matchedRate | number : '1.3-3'}}%</div>
                            </div>
                            <div class="col-2">
                                <div>APR</div>
                                <div class="detailValue">{{o.opportunityInfo.matchedApr | number : '1.3-3'}}%</div>
                            </div>
                            <div class="col-2">
                                <div>P&I</div>
                                <div class="detailValue">${{o.opportunityInfo.marketPayment | number : '1.0-0' | null}}
                                </div>
                            </div>
                            <div class="col-4">
                                <div>Cost to Borrower</div>
                                <div class="detailValue">${{o.opportunityInfo.closingCost | number : '1.0-0' | null}}
                                </div>
                            </div>
                            <div class="col-12" style="padding-top: 10px; padding-bottom:10px ">
                                <button class="btn btn-primary" (click)="onSelectThisOpportunity(o)">Select this
                                    Opportunity</button>
                            </div>
                        </div>
                    </div>
                </div>

            </ng-container>
        </ng-container>


        <!--Have Selected Opportunity-->
        <ng-container *ngIf="(isHaveSelectedOpportunityMode$ | async) && opportunity$ | async as o">
            <div class="Vert-15"></div>
            <div class="row detailRow">
                <div class="col-lg-6 col-sm-12 col-xs-12" *ngIf="lgvClientSvc.ClientInfo$ | async as clientInfo">
                    <div class="detailLabel">Client</div>
                    <div class="detailValue">{{clientInfo.firstName}} {{clientInfo.lastName}}</div>
                </div>
                <div class="col-lg-6 col-sm-12 col-xs-12" *ngIf="loanApplication?.loanInfo?.subjectPropertyAddress as prop">
                    <div class="detailLabel">Property</div>
                    <div class="detailValue">{{prop.street}} {{prop.city}} {{prop.state}} {{prop.zip}}</div>
                </div>
            </div>
            <div class="row detailRow" *ngIf="!(authMgr.IsClient$ | async)">
                <div class="col-lg-12 col-sm-12 col-xs-12 Vert-15"></div>
                <div class="col-lg-12 col-sm-12 col-xs-12 detailLabel">Product</div>
                <div class="col-lg-12 col-sm-12 col-xs-12 detailValue">{{o.opportunityInfo.productName}}</div>
            </div>
            <div class="Vert-15"></div>
            <div class="row detailRow">
                <div class="col-lg-4 col-sm-12 col-xs-12" *ngIf="!(authMgr.IsClient$ | async)">
                    <div class="detailLabel">Lender Name</div>
                    <div class="detailValue">{{o.opportunityInfo.investor}}</div>
                </div>
                <div class="col-lg-4 col-sm-12 col-xs-12">
                    <div class="detailLabel">Lock Exp.</div>
                    <div class="detailValue">{{calcLockExpirationDate(o)}}</div>
                </div>
                <div class="col-lg-4 col-sm-12 col-xs-12">
                    <div class="detailLabel">Lock Period (Days)</div>
                    <div class="detailValue">{{o.opportunityInfo.lockPeriod}}</div>
                </div>
            </div>
            <div class="row detailRow">
                <div class="col-lg-4 col-sm-12 col-xs-12">
                    <div class="detailLabel">Rate</div>
                    <div class="detailValue">{{o.opportunityInfo.matchedRate | number : '1.3-3'}}%</div>
                </div>
                <div class="col-lg-4 col-sm-12 col-xs-12">
                    <div class="detailLabel">APR</div>
                    <div class="detailValue">{{o.opportunityInfo.matchedApr | number : '1.3-3'}}%</div>
                </div>
                <div class="col-lg-4 col-sm-12 col-xs-12">
                    <div class="detailLabel">Loan Amount</div>
                    <div class="detailValue">${{o.opportunityInfo.loanAmount | number : '1.0-0' | null}}</div>
                </div>
            </div>
            <div class="row detailRow">
                <div class="col-lg-4 col-sm-12 col-xs-12">
                    <div class="detailLabel">Price | Cost</div>
                    <div class="detailValue">{{o.opportunityInfo.matchedPrice | number : '1.3-3' | null}}% |
                        ${{o.opportunityInfo.pointsCost | number : '1.0-0' | null}}</div>
                </div>
                <div class="col-lg-4 col-sm-12 col-xs-12">
                    <div class="detailLabel">Origination</div>
                    <div class="detailValue">{{compensationTypeForDisplay}}</div>
                </div>
                <div class="col-lg-4 col-sm-12 col-xs-12">
                    <div class="detailLabel">Impounds</div>
                    <div class="detailValue">{{impoundsDisplay}}</div>
                </div>
            </div>
            <!-- <div class="row detailRow">
                <div class="col-12">
                    <div class="detailLabel">Include Admin Fee in Rate:</div>
                    <div class="detailValue" *ngIf="pricingScenario">{{lenderFeeWaiverDisplay}}</div>
                </div>
            </div> -->

            <div class="Vert-15"></div>
            <div *ngIf="o.opportunityInfo?.groupAdjustmentProperties as adjustments">
                <table>
                    <tr>
                        <td><b>Pricing Adjustment</b></td>
                        <td class="alignRight"><b>Amount</b></td>
                    </tr>
                    <tr class="tr-underline">
                        <td colspan="2"></td>
                    </tr>
                    <ng-container *ngFor="let grpAdj of adjustments">
                        <tr style=" position: relative; width: 60%" *ngFor="let adj of grpAdj.adjustments">
                            <td>{{adj.key}}</td>
                            <td class="alignRight"><b>{{adj.adj}}</b></td>
                        </tr>
                    </ng-container>
                    <tr class="total">
                        <td>Total Adjustments:</td>
                        <td class="alignRight" style="border-top:1px solid black"><b>{{(totalAdjustments()) | number :
                                '1.0-3'}}</b></td>
                    </tr>
                </table>
            </div>
            <div class="Vert-15"></div>

            <div class="row">
                <p>Est. Due at Closing: <strong>{{ calcEstTotalDue(o?.opportunityInfo) | currency : 'USD' : 'symbol' : '1.0'}}</strong></p>
            </div>

        </ng-container>
    </mat-dialog-content>

    <div class="Vert-10"></div>

    <div class="row">
        <div class="col-12" align="end">

            <button mat-button class="btn btn-primary float-end" (click)="onSubmit()"
                *ngIf="isHaveSelectedOpportunityMode$ | async">Submit Lock Request</button>

            <button mat-stroked-button (click)="onCancel()" class="btn btn-secondary float-end"
                style="margin-right:10px;">
                Cancel
            </button>
        </div>
    </div>

    <div class="Vert-15"></div>

</div>